import { render, staticRenderFns } from "./JsonUpload.vue?vue&type=template&id=2ec9a383&scoped=true"
import script from "./JsonUpload.vue?vue&type=script&lang=ts"
export * from "./JsonUpload.vue?vue&type=script&lang=ts"
import style0 from "./JsonUpload.vue?vue&type=style&index=0&id=2ec9a383&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec9a383",
  null
  
)

export default component.exports